import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Tabs } from 'antd';
import Edit from './UI.Edit';
import Safe from './UI.Safe';

const css = require('./index.scss');
const TabPane = Tabs.TabPane;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
  type?: number; // 0 => 新增 1 => 查看/修改
  userId?: string;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount () {
      ModulesAction.updateSecurityMgr({userId: this.props.userId});
    }
    
    render() {
        const type = this.props.type && this.props.type;
        const userId = this.props.userId && this.props.userId;
        const isActivated = this.modulesState.userInfo && this.modulesState.userInfo.isActivated;
        const acceptStatus = this.modulesState.userInfo && this.modulesState.userInfo.acceptStatus;
        return (
            <Tabs>
              <TabPane tab='查看用户' key='info'>
                <Edit type={1} userId={userId}/>
              </TabPane>
              {
                isActivated &&
                <TabPane tab='用户安全' key='safe'>
                  <Safe userId={userId} />
                </TabPane>
              }
            </Tabs>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.View.tsx